// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stocklogistics.eshopreplenishment', {
        url: '/eshopreplenishment',
        templateUrl: 'main/stocklogistics/eshopreplenishment/eshopreplenishment.tpl.html',
        controller: 'EshopReplenishmentController as vm',
        resolve: {
            locations: locationsResolver
        }
    });
}

// @ngInject
function locationsResolver(StockLogisticsApiService) {
    return StockLogisticsApiService.getLocations();
}


// @ngInject
function EshopReplenishmentController($scope, $translate, $state, $interval, $timeout, AuthService, ProductsApiService, loadSpinnerService,
                                   OrdersApiService, locations, ToasterService, StockLogisticsApiService) {
    var vm = this;
    var int32Max = 2147483647;

    var articlesGrid = {};
    var rowData = [];
    var rowCollection = new wijmo.collections.CollectionView(rowData);

    var locationsGrid = {};
    var locationsCollection = new wijmo.collections.CollectionView(locations);

    var stocksData = [];
    var stockLogisticsData = [];
    var quantityInTansitData = [];

    vm.searchTerm = "";
    vm.numberOfResults = 9999;
    vm.articleVariants = [];
    vm.locations = locations;
    vm.visibleLocations = [];
    vm.minDiffToCreateSuggestion = 2;
    vm.lowerThresholdQuantity = 1;
    vm.moveMaximum = 1;
    vm.handleNegativeEshopQuantities = true;

    vm.selectedCollection = {};

    vm.captureArticlesGrid = captureArticlesGrid;
    vm.captureLocationsGrid = captureLocationsGrid;

    vm.searchArticles = searchArticles;
    vm.insertStockQuantities = insertStockQuantities;
    vm.fetchQuantityInTransitData = fetchQuantityInTransitData;
    vm.submitAndCreateOrders = submitAndCreateOrders;
    vm.validateGridRow = validateGridRow;
    vm.preventChangingOfIsOkValue = preventChangingOfIsOkValue;

    vm.changeToSearchTab = changeToSearchTab;
    vm.changeToLocationsTab = changeToLocationsTab;
    vm.tabSelection = {
        search: true,
        locations: false
    };
    vm.selectAllLocations = selectAllLocations;
    vm.selectNoLocations = selectNoLocations;
    vm.canAccess = AuthService.canAccess;

    activate();

    function activate() {

        var counter = 0;
        _.forEach(vm.locations, function(location) {
            counter++;
            location.isVisible = true;
            location.distributionWeight = 1;
            location.locationPriority = counter;

            if (_.toLower(location.locationType.locationSystemType) === "eshop") {
                location.outDeliverable = false;
                location.inDeliverable = true;
            } else {
                location.outDeliverable = true;
                location.inDeliverable = false;
            }

        });
        setVisibleLocations();
    }

    function captureArticlesGrid(s) {
        articlesGrid = s;
        articlesGrid.initialize({
            autoGenerateColumns: false,
            selectionMode: wijmo.grid.SelectionMode.Row,
            allowDragging: wijmo.grid.AllowDragging.None,
            allowResizing: wijmo.grid.AllowResizing.Columns,
            itemsSource: rowCollection
        });

        articlesGrid.itemFormatter = function(panel, rowNum, colNum, cell) {
            var style = cell.style;
            var regularCellType = wijmo.grid.CellType.Cell;

            if (panel.cellType === regularCellType) {
                var relatedDataRow = rowData[rowNum];
                var quantityValues = [];
                var transferQuantityValues = [];
                var locationNumbers = [];
                var locationIds = [];
                _.forEach(vm.visibleLocations, function(location) {
                    quantityValues.push(relatedDataRow[location.id]);

                    var transferQuantityValue = relatedDataRow[location.id + 'Difference'];
                    if (transferQuantityValue !== undefined && !_.isNumber(transferQuantityValue)) {
                        transferQuantityValue = parseInt(transferQuantityValue);
                    }
                    transferQuantityValues.push(transferQuantityValue);

                    locationNumbers.push(location.locationNumber);
                    locationIds.push(location.id);
                });
                var maxValue = _.max(quantityValues);
                var minValue = _.min(quantityValues);
                var maxTransferValue = _.max(transferQuantityValues);
                var minTransferValue = _.min(transferQuantityValues);

                var transferQuantitySum = _.sum(transferQuantityValues);
                var fromLocationCount = 0;
                _.forEach(transferQuantityValues, function(num) {
                    if (num < 0) {
                        fromLocationCount += 1;
                    }
                });

                var col = panel.columns[colNum];

                var currentQuantityCellValue = relatedDataRow[col.binding];

                var columnBindingIsLocationId = _.some(locationIds, function(locationId) {
                    return locationId.toString() === col.binding;
                });
                var columnHeaderIsLocationNumber = _.some(locationNumbers, function(locationNumber) {
                    return locationNumber === col.header;
                });
                var columnBindingIsLocationNumberAndDiffMarker = _.some(locationIds, function(locationId) {
                    return locationId.toString() + 'Difference' === col.binding;
                });

                if (columnBindingIsLocationId && columnHeaderIsLocationNumber) {
                    // cell is currentStockCell
                    if (minValue !== undefined && currentQuantityCellValue === minValue) {
                        cell.style.color = "#000000";
                        cell.style.backgroundColor = "#f7a7a7";
                    } else if (maxValue !== undefined && currentQuantityCellValue === maxValue) {
                        cell.style.color = "#000000";
                        cell.style.backgroundColor = "#93e0a5";
                    } else {
                        cell.style.color = "";
                        cell.style.backgroundColor = "";
                    }
                } else if (columnBindingIsLocationNumberAndDiffMarker && columnHeaderIsLocationNumber) {
                    // cell is transferSuggestionCell
                    if (transferQuantitySum !== undefined && transferQuantitySum !== "" && (transferQuantitySum !== 0 || fromLocationCount > 1)) {
                        cell.style.color = "#000000";
                        cell.style.backgroundColor = "#f7a7a7";
                    } else {
                        cell.style.color = "";
                        cell.style.backgroundColor = "";
                    }
                }
            }
        };
    }

    function captureLocationsGrid(s) {
        locationsGrid = s;
        locationsGrid.initialize({
            autoGenerateColumns: false,
            selectionMode: wijmo.grid.SelectionMode.Row,
            allowDragging: wijmo.grid.AllowDragging.None,
            allowResizing: wijmo.grid.AllowResizing.None,
            itemsSource: locationsCollection
        });
    }

    function generateArtilcesGridColumns() {
        articlesGrid.columns.clear();

        var altArtNumberColumn = new wijmo.grid.Column();
        altArtNumberColumn.binding = 'alternativeArticleNumberAndArticleName';
        altArtNumberColumn.header = $translate.instant('article.article');
        altArtNumberColumn.allowSorting = false;
        altArtNumberColumn.width = 200;
        altArtNumberColumn.isReadOnly = true;
        articlesGrid.columns.push(altArtNumberColumn);

        var variantDetail1Column = new wijmo.grid.Column();
        variantDetail1Column.binding = 'variantDetail1.variantDetailName';
        variantDetail1Column.header = $translate.instant('article.variantdetail1');
        variantDetail1Column.allowSorting = false;
        variantDetail1Column.width = 100;
        variantDetail1Column.isReadOnly = true;
        articlesGrid.columns.push(variantDetail1Column);

        var variantDetail2Column = new wijmo.grid.Column();
        variantDetail2Column.binding = 'variantDetail2.variantDetailName';
        variantDetail2Column.header = $translate.instant('article.variantdetail2');
        variantDetail2Column.allowSorting = false;
        variantDetail2Column.width = 50;
        variantDetail2Column.isReadOnly = true;
        articlesGrid.columns.push(variantDetail2Column);

        _.forEach(vm.locations, function(location) {
            if (location.isVisible) {
                var locationColumn = new wijmo.grid.Column();
                locationColumn.binding = location.id.toString();
                locationColumn.header = location.locationNumber;
                locationColumn.allowSorting = false;
                locationColumn.width = 40;
                locationColumn.isReadOnly = true;
                articlesGrid.columns.push(locationColumn);
            }
        });

        var checkboxColumn = new wijmo.grid.Column();
        checkboxColumn.binding = 'isOk';
        checkboxColumn.header = $translate.instant('common.ok');
        checkboxColumn.allowSorting = false;
        checkboxColumn.width = 50;
        checkboxColumn.isReadOnly = false;
        articlesGrid.columns.push(checkboxColumn);

        _.forEach(vm.locations, function(location) {
            if (location.isVisible) {
                var locationColumn = new wijmo.grid.Column();
                locationColumn.binding = location.id + "" + "Difference";
                locationColumn.header = location.locationNumber;
                locationColumn.allowSorting = false;
                locationColumn.width = 40;
                locationColumn.isReadOnly = false;
                articlesGrid.columns.push(locationColumn);
            }
        });

        articlesGrid.invalidate();
    }

    function generateArticlesRowData() {
        rowData.length = 0;
        _.forEach(vm.articleVariants, function(articleVariant) {
            articleVariant.isOk = false;
            rowData.push(articleVariant);
        });

        articlesGrid.invalidate();
        rowCollection.refresh();
    }

    function searchArticles() {
        if (vm.searchTerm.length < 3 && (!AuthService.canAccess('article', 'readList') && !AuthService.canAccess('article', 'read'))) {
            return;
        }

        loadSpinnerService.start('mainSpinner');
        ProductsApiService.getProductVariants(0, vm.searchTerm, vm.numberOfResults, vm.selectedCollection.id, true).then(function (response) {
            vm.articleVariants = response.data;

            _.forEach(vm.articleVariants, function(articleVariant) {
                articleVariant['alternativeArticleNumberAndArticleName'] = articleVariant.article.alternativeArticleNumber + " " + articleVariant.article.articleName;
            });

            setVisibleLocations();
            generateArtilcesGridColumns();
            generateArticlesRowData();
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function insertStockQuantities() {
        loadSpinnerService.start('mainSpinner');

        zeroAllGridValues();

        var articleVariantIdsAndLocationIds = [];
        _.forEach(rowData, function(row) {
            _.forEach(vm.locations, function (location) {
                if (location.isVisible) {
                    articleVariantIdsAndLocationIds.push({ articleVariantId: row.id, locationId: location.id });
                }
            });
        });

        ProductsApiService.getProductVariantsStocks(articleVariantIdsAndLocationIds).then(function(response) {
            stocksData = response.data;
            insertStocksDataIntoGrid(response.data);

            createQuantityTransferSuggestions();

        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function fetchQuantityInTransitData() {
        loadSpinnerService.start('mainSpinner');
        var articleVariantIdsAndLocationIds = [];
        _.forEach(rowData, function(row) {
            _.forEach(vm.locations, function (location) {
                if (location.isVisible) {
                    articleVariantIdsAndLocationIds.push({ articleVariantId: row.id, locationId: location.id });
                }
            });
        });

        ProductsApiService.getProductVariantsInTransitValues(articleVariantIdsAndLocationIds).then(function(response) {
            quantityInTansitData = response.data;
            adjustStocksDataWithTransferQuantities(response.data);
            createQuantityTransferSuggestions();
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function submitAndCreateOrders() {
        var locationsArticleVariantsLinkStructures = [];

        _.forEach(rowData, function(row) {

            if (row.isOk) {
                var currentTransferObjects = [];

                var outLocation = _.find(vm.visibleLocations, function(location) {
                    return row[location.id + "Difference"] < 0;
                });

                _.forEach(vm.visibleLocations, function(location) {
                    if (row[location.id + "Difference"] > 0) {
                        currentTransferObjects.push({
                            fromLocationId: outLocation.id,
                            toLocationId: location.id,
                            articleVariantId: row.id,
                            quantity: parseInt(row[location.id + "Difference"])
                        });
                    }
                });

                var totalSum = parseInt(row[outLocation.id + "Difference"]);
                _.forEach(currentTransferObjects, function(transferObject) {
                    totalSum += parseInt(transferObject.quantity);
                });

                if (totalSum === 0) {
                    _.forEach(currentTransferObjects, function(transferObject) {
                        locationsArticleVariantsLinkStructures.push(transferObject);
                    });
                }
            }
        });

        OrdersApiService.createMultipleInternalOrders(locationsArticleVariantsLinkStructures).then(function(response) {
            console.log("Success");
            $state.go('order.ordersearch');
        }, function(error) {
            console.log("Error");
        });

    }

    function createQuantityTransferSuggestions() {
        // Abstraction
        var findMax = true;
        var findMin = false;

        // Find all chosen locations.
        var visibleLocations = _.filter(vm.locations, function(location) {
            return location.isVisible;
        });

        _.forEach(rowData, function(row) {
            var locationsWithMaxQuantity = getLocationsWithEdgeStockQuantity(row, visibleLocations, findMax);
            var locationsWithMinQuantity = getLocationsWithEdgeStockQuantity(row, visibleLocations, findMin);

            locationsWithMaxQuantity = _.sortBy(locationsWithMaxQuantity, function(location) { return -location.locationPriority; });
            locationsWithMinQuantity = _.sortBy(locationsWithMinQuantity, function(location) { return location.locationPriority; });

            if (locationsWithMaxQuantity[0] === undefined || locationsWithMinQuantity[0] === undefined) {
                // Row does not have a maximum or minimum value.
                return;
            }

            var maxValue = locationsWithMaxQuantity[0]['stockQuantity'] + locationsWithMaxQuantity[0]['stockQuantityDifference'];
            var minValue = locationsWithMinQuantity[0]['stockQuantity'] + locationsWithMinQuantity[0]['stockQuantityDifference'];
            var diff = maxValue - minValue;

            var maxLocation = locationsWithMaxQuantity[0];
            var minLocation = locationsWithMinQuantity[0];

            var minLocationRelatedStock = _.find(stocksData, function(stock) {
                return stock.location.id === minLocation.id && stock.articleVariant.id === row.id;
            });

            var eshops = _.filter(visibleLocations, function(location) {
                return _.toLower(location.locationType.locationSystemType) === 'eshop';
            });

            _.forEach(eshops, function(eshop) {
                var normalizationValue = 0 - Math.max(row[eshop.id], 0 - row[maxLocation.id]);
                if (vm.handleNegativeEshopQuantities && normalizationValue > 0) {
                    row[maxLocation.id + "Difference"] = row[maxLocation.id + "Difference"] - normalizationValue;
                    row[eshop.id + "Difference"] = row[eshop.id + "Difference"] + normalizationValue;
                } else if (!vm.handleNegativeEshopQuantities && normalizationValue < 0) {
                    row[eshop.id + "Difference"] = row[eshop.id + "Difference"] + normalizationValue;
                    row[minLocation.id + "Difference"] = row[minLocation.id + "Difference"] - normalizationValue;
                }
            });

            var rowHasTransferValues = false;
            _.forEach(vm.visibleLocations, function(location) {
                if (row[location.id + "Difference"] === 0 || row[location.id + "Difference"] === "") {
                    row[location.id + "Difference"] = undefined;
                }
                if (row[location.id + "Difference"] !== undefined) {
                    rowHasTransferValues = true;
                }
            });

            if (rowHasTransferValues) {
                row.isOk = true;
            }
        });
        articlesGrid.invalidate();
    }

    function removeStocksDataForStockLogistics(stockLogistics) {
        _.forEach(stockLogistics, function(stockLogistic) {
            var relatedRow = _.find(rowData, function(row) {
                return row.id === stockLogistic.articleVariant.id;
            });

            _.pull(rowData, relatedRow);
        });
        articlesGrid.invalidate();
        rowCollection.refresh();
    }

    function adjustStocksDataWithTransferQuantities(quantityInTransits) {
        _.forEach(quantityInTransits, function(transitData) {
            var relatedRow = _.find(rowData, function(row) {
                return row.id === transitData.articleVariant.id;
            });

            if (relatedRow !== undefined) {
                var relatedStock = _.find(stocksData, function(stock) {
                    return stock.articleVariant.id === transitData.articleVariant.id && stock.location.id === transitData.location.id;
                });

                if (relatedStock !== undefined) {
                    relatedRow[transitData.location.id] = relatedStock.quantity + transitData.quantityInTransit;
                } else {
                    relatedRow[transitData.location.id] = transitData.quantityInTransit;
                }

                if (relatedRow[transitData.location.id] < 0) {
                    relatedRow[transitData.location.id] = undefined;
                }
            }
        });

        var tempRowData = _.reject(rowData, function(row) {
            var allRowsAreValueless = true;
            _.forEach(vm.visibleLocations, function(location) {
                if (row[location.id] !== undefined) {
                    allRowsAreValueless = false;
                }
            });
            return allRowsAreValueless;
        });

        rowData.length = 0;
        _.forEach(tempRowData, function(row) {
            rowData.push(row);
        });

        articlesGrid.invalidate();
        rowCollection.refresh();
    }

    function getLocationsWithEdgeStockQuantity(row, inLocations, findMax) {
        var locations = [];

        // Remove locations without stockQuantity.
        _.forEach(inLocations, function(loc) {
            if (row[loc.id] !== undefined) {
                locations.push(loc);
            }
        });

        if (locations.length < 1) {
            return [];
        }

        var locationsAndQuantity = [];

        _.forEach(locations, function(location) {
            location['stockQuantity'] = row[location.id];
            location['stockQuantityDifference'] = row[location.id + "" + "Difference"];
            locationsAndQuantity.push(location);
        });

        locationsAndQuantity = _.sortBy(locationsAndQuantity, function(location) {
            if (findMax) { // Descending
                return -(location['stockQuantity'] + location['stockQuantityDifference']);
            } else { // Ascending
                return (location['stockQuantity'] + location['stockQuantityDifference']);
            }
        });

        var maxValue = locationsAndQuantity[0]['stockQuantity'] - locationsAndQuantity[0]['stockQuantityDifference'];

        locationsAndQuantity = _.filter(locationsAndQuantity, function(location) {
            return (location['stockQuantity'] - locationsAndQuantity[0]['stockQuantityDifference']) === maxValue;
        });

        return locationsAndQuantity;
    }

    function changeToSearchTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.search = true;
    }

    function changeToLocationsTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.locations = true;
        locationsGrid.invalidate();
        locationsCollection.refresh();
    }

    function selectAllLocations() {
        _.forEach(vm.locations, function(location) {
            location.isVisible = true;
        });
        locationsGrid.invalidate();
        locationsCollection.refresh();
    }

    function selectNoLocations() {
        _.forEach(vm.locations, function(location) {
            location.isVisible = false;
        });
        locationsGrid.invalidate();
        locationsCollection.refresh();
    }

    function setAllTabSelectionsToFalse() {
        var keys = Object.keys(vm.tabSelection);
        _.forEach(keys, function(key) {
            vm.tabSelection[key] = false;
        });
    }

    function insertStocksDataIntoGrid(stocks) {
        _.forEach(stocks, function(stock) {
            var foundRow = _.find(rowData, function(row) {
                return row.id === stock.articleVariant.id;
            });

            if (foundRow !== undefined) {
                foundRow[stock.location.id] = stock.quantity;
                foundRow[stock.location.id + "Difference"] = 0;
            }

        });

        var eshops = [];
        _.forEach(vm.visibleLocations, function(location) {
            if (_.toLower(location.locationType.locationSystemType) === "eshop") {
                eshops.push(location);
            }
        });

        // Keep only the rows that actually has stock values.
        var rowDataCopy = angular.copy(rowData);
        rowData.length = 0;
        _.forEach(rowDataCopy, function(row) {
            var rowHasValues = false;
            _.forEach(vm.visibleLocations, function(location) {
                var currentEshop = _.find(eshops, function(eshop) { return location.id === eshop.id; });
                if (row[location.id] !== undefined && currentEshop !== undefined) {
                    rowHasValues = true;
                }
            });

            if (rowHasValues) {
                rowData.push(row);
            }
        });

        rowCollection.refresh();
        articlesGrid.invalidate();
    }

    function setVisibleLocations() {
        vm.visibleLocations = _.filter(vm.locations, function(location) {
            return location.isVisible;
        });
    }

    function zeroAllGridValues() {
        _.forEach(rowData, function(row) {
            _.forEach(vm.visibleLocations, function(location) {
                var stock = _.find(stocksData, function(stock) {
                    return stock.articleVariant.id === row.id && stock.location.id === location.id;
                });
                if (stock !== undefined) {
                    row[location.id] = 0;
                } else {
                    row[location.id] = undefined;
                }
                row[location.id + "Difference"] = undefined;
                row.isOk = false;
            });
        });
    }

    function validateGridRow(grid) {
        var rowNumber = grid.selection.row;
        var correspondingRowData = grid.rows[rowNumber].dataItem;

        var transferQuantityValues = [];
        _.forEach(vm.visibleLocations, function(location) {
            var transferQuantityValue = correspondingRowData[location.id + 'Difference'];
            if (transferQuantityValue === undefined) {
                transferQuantityValue = 0;
            } else if (transferQuantityValue !== undefined && !_.isNumber(transferQuantityValue)) {
                transferQuantityValue = parseInt(transferQuantityValue);
            }

            transferQuantityValues.push(transferQuantityValue);
        });

        var transferQuantitySum = _.sum(transferQuantityValues);
        var fromLocationCount = 0;
        _.forEach(transferQuantityValues, function(num) {
            if (num < 0) {
                fromLocationCount += 1;
            }
        });

        if (transferQuantitySum !== 0 || fromLocationCount > 1) {
            correspondingRowData.isOk = false;
        }
        articlesGrid.invalidate();
        rowCollection.refresh();
    }

    function preventChangingOfIsOkValue(grid, e) {
        var rowNumber = grid.selection.row;
        var colNumber = grid.selection.col;
        var correspondingRowData = grid.rows[rowNumber].dataItem;

        var transferQuantityValues = [];
        _.forEach(vm.visibleLocations, function(location) {
            var transferQuantityValue = correspondingRowData[location.id + 'Difference'];
            if (transferQuantityValue === undefined) {
                transferQuantityValue = 0;
            } else if (transferQuantityValue !== undefined && !_.isNumber(transferQuantityValue)) {
                transferQuantityValue = parseInt(transferQuantityValue);
            }

            transferQuantityValues.push(transferQuantityValue);
        });

        var transferQuantitySum = _.sum(transferQuantityValues);
        var fromLocationCount = 0;
        _.forEach(transferQuantityValues, function(num) {
            if (num < 0) {
                fromLocationCount += 1;
            }
        });

        var selectedColumnBinding = grid.columns[colNumber].binding;

        if (selectedColumnBinding === 'isOk' && (transferQuantitySum !== 0 || fromLocationCount > 1)) {
            correspondingRowData.isOk = false;
            e.cancel = true;
        } else if (selectedColumnBinding !== 'isOk' && (transferQuantitySum !== 0 || fromLocationCount > 1)) {
            correspondingRowData.isOk = false;
        }

        articlesGrid.invalidate();
        rowCollection.refresh();
    }

    function applyScope() {
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    function showWarningToaster(message) {
        var title = $translate.instant('common.warning');
        ToasterService.showWarning(message, title);
    }
}


angular
    .module('stocklogistics.eshopreplenishment', [])
    .config(stateConfig)
    .controller('EshopReplenishmentController', EshopReplenishmentController);
